import { useEffect, useRef, useState } from 'react'

import { CareGiver } from '../../../../api/services/dd_panel_caregiver/types.ts'
import Button from '../../../common/Button/Button.tsx'
import Input from '../../../common/forms/Input/Input.tsx'

const CareGiverForm = ({
  formik,
  careGiverData
}: {
  formik: any
  careGiverData: CareGiver | null
}) => {
  const [editForm, setEditForm] = useState(!careGiverData)
  const firstInputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (editForm && firstInputRef.current) {
      firstInputRef.current.focus()
    }
  }, [editForm])

  const handleSubmit = (e: React.FormEvent) => {
    setEditForm(false)
    formik.handleSubmit(e)
  }

  return (
    <form onSubmit={handleSubmit}>
      <Input
        ref={firstInputRef}
        id="first_name"
        name="first_name"
        type="text"
        placeholder="Imię opiekuna"
        formik={formik}
        disabled={!editForm}
      />

      <Input
        id="last_name"
        name="last_name"
        type="text"
        placeholder="Nazwisko opiekuna"
        formik={formik}
        disabled={!editForm}
      />

      <Input
        id="email"
        name="email"
        type="text"
        placeholder="E-mail"
        formik={formik}
        disabled={!editForm}
      />

      {!!careGiverData && (
        <Button
          variant="filled"
          size="medium"
          color={editForm ? 'secondary' : 'primary'}
          onClick={() => setEditForm(!editForm)}
          className="my-8 mr-4"
        >
          {editForm ? 'Anuluj' : 'Zmień'}
        </Button>
      )}

      {editForm && (
        <Button
          variant="filled"
          size="medium"
          color="primary"
          type="submit"
          className="my-8"
          disabled={!formik.isValid || formik.isSubmitting || !formik.dirty}
        >
          {formik.isSubmitting
            ? 'Wysyłanie...'
            : careGiverData
              ? 'Wyślij zmiany'
              : 'Dodaj'}
        </Button>
      )}
    </form>
  )
}

export default CareGiverForm
